import { DistributionReason, IraContributionType, TaxWithholdingValueType, CashJournalPayload } from '@Types'
import isEmpty from 'lodash.isempty'
import { convertToValidDate } from '../../utils'
import { generateExternalTransferId } from '../../utils/payloadHelpers'
import { getFrequencyInterval } from '../ACHTransferForm/utils/getFrequencyInterval'
import { getFrequencyUnit } from '../ACHTransferForm/utils/getFrequencyUnit'
import { getFeeOverrideDetails } from '../TransferFees/utils/getFeeOverrideDetails'
import { CashJournalValues } from './Types'

const formatPayload = (
  {
    transferAmountRaw,
    fromAccount,
    toAccount,
    totalBalanceCheckbox,
    contributionType,
    contributionReason,
    contributionYear,
    distributionReason,
    federalTaxWithholdingType,
    federalTaxWithholdingAmountRaw,
    stateTaxWithholdingType,
    stateTaxWithholdingAmountRaw,
    transferRecurrence,
    transferStartDate,
    transferFrequency,
    numberOfTransfers,
    whenToSend,
    transferScheduledDate,
    fees,
    optOutFormProvided
  }: CashJournalValues,
  isScheduledTransfer: boolean
) => {
  const cashJournalPayload: CashJournalPayload = {
    amount: Number(transferAmountRaw) || undefined,
    externalId: generateExternalTransferId(),
    sourceAccount: fromAccount!,
    destinationAccount: toAccount!.trim(),
    isFullDisbursement: totalBalanceCheckbox!,
    ...(contributionType && {
      iraContributionDetails: {
        type: contributionType as IraContributionType,
        applyToPriorYear: contributionYear === 'PREVIOUS'
      }
    }),
    ...(contributionReason && {
      iraContributionDetails: {
        type: contributionReason as IraContributionType,
        applyToPriorYear: contributionYear === 'PREVIOUS'
      }
    }),
    ...(distributionReason && {
      iraDistributionDetails: {
        distributionReason: distributionReason as DistributionReason,
        ...(federalTaxWithholdingType && {
          federalTaxWithholding: {
            valueType: federalTaxWithholdingType as TaxWithholdingValueType,
            value: federalTaxWithholdingAmountRaw!
          }
        }),
        ...(stateTaxWithholdingType && {
          stateTaxWithholding: {
            valueType: stateTaxWithholdingType as TaxWithholdingValueType,
            value: stateTaxWithholdingAmountRaw!
          }
        }),
        ...(optOutFormProvided && { hasStateWithholdingWaiver: optOutFormProvided })
      }
    }),
    ...(isScheduledTransfer && {
      ...(transferRecurrence === 'RECURRING' && {
        startDate: convertToValidDate(transferStartDate!),
        frequencyUnit: getFrequencyUnit(transferFrequency!),
        frequencyInterval: getFrequencyInterval(transferFrequency!),
        ...(numberOfTransfers &&
          Number(numberOfTransfers) > 0 && {
            occurrences: Number(numberOfTransfers)
          })
      }),
      ...(transferRecurrence === 'ONE_TIME' && {
        startDate: convertToValidDate(transferScheduledDate!),
        frequencyUnit: 'DAY',
        frequencyInterval: 1,
        ...(whenToSend === 'IN_THE_FUTURE' && { occurrences: 1 }),
        ...(whenToSend === 'IMMEDIATELY' &&
          numberOfTransfers &&
          Number(numberOfTransfers) > 0 && {
            occurrences: Number(numberOfTransfers)
          })
      })
    }),
    ...(!isEmpty(fees) && { feeOverrideDetails: getFeeOverrideDetails(fees) })
  }
  return cashJournalPayload
}

export default formatPayload
